// FIXME: refactor this to not use the document and window API
/* eslint-disable no-restricted-globals */
import { NgZone, enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideLoaders } from '@frontend/loaders';
import { provideBrowserBackDetection, provideNativeTransitionDetection } from '@frontend/sports/web/platform-lib';
import { AppComponent, bootloader, provideVanillaCore } from '@frontend/vanilla/core';
import { setAutoFreeze } from 'immer';

import { routes } from './app-routing.module';
import { AppModule } from './app.module';
import { provideRouterOverride } from './sports-router';

declare global {
    interface Window {
        clientConfig: {
            msApp: {
                viewTransitionsEnabled: boolean;
                viewTransitionsDirectionalityEnabled: boolean;
                viewTransitionsNativeTransitionSkippingEnabled: boolean;
            };
        };
    }
}

if (process.env.NODE_ENV === 'production') {
    setAutoFreeze(false);
    enableProdMode();
}

const disableAnimations = !('animate' in document.documentElement); //[INC1293113] disabling animations, when they're are not supported by OS. For example iOS <13

const enableViewTransitionDirectionality = () => {
    return window.clientConfig.msApp.viewTransitionsEnabled && window.clientConfig.msApp.viewTransitionsDirectionalityEnabled;
};

const enableViewTransitionNativeTransitionSkipping = () => {
    return window.clientConfig.msApp.viewTransitionsEnabled && window.clientConfig.msApp.viewTransitionsNativeTransitionSkippingEnabled;
};

bootloader()
    .then(() =>
        bootstrapApplication(AppComponent, {
            providers: [
                {
                    provide: NgZone,
                    useValue: new NgZone({ shouldCoalesceEventChangeDetection: true }),
                },
                provideAnimationsAsync(disableAnimations ? 'noop' : 'animations'),
                provideRouterOverride(routes, window.clientConfig.msApp.viewTransitionsEnabled),
                provideBrowserBackDetection(enableViewTransitionDirectionality() ? 'backdetection' : 'noop'),
                provideNativeTransitionDetection(enableViewTransitionNativeTransitionSkipping() ? 'nativetransitiondetection' : 'noop'),
                provideVanillaCore(),
                provideLoaders(),
                importProvidersFrom(AppModule),
            ],
        }),
    )
    .catch((err: any) => console.error(err));
